export const skills = [
  {
    category: "Frontend",
    items: [
      { skill: "React", color: "#0364d4" },
      { skill: "TypeScript", color: "#007acc" },
      { skill: "Next.js", color: "#000000" },
      { skill: "JavaScript", color: "#f0db4f" },
      { skill: "HTML/CSS", color: "#f06529" },
      { skill: "Tailwind", color: "#38bdf8" },
      { skill: "Framer", color: "#0055ff" },
    ]
  },
  {
    category: "Animation",
    items: [
      { skill: "GSAP", color: "#88ce02" },
      { skill: "Framer Motion", color: "#ff008c" },
      { skill: "Three.js", color: "#000000" },
      { skill: "WebGL", color: "#990000" },
      { skill: "Canvas API", color: "#f0db4f" },
      { skill: "Shaders", color: "#5a67d8" },
      { skill: "Scroll FX", color: "#e05a33" },
    ]
  },
  {
    category: "Design",
    items: [
      { skill: "Figma", color: "#000000" },
      { skill: "Photoshop", color: "#31a8ff" },
      { skill: "Illustrator", color: "#ff9a00" },
      { skill: "After Effects", color: "#9999ff" },
      { skill: "Prototyping", color: "#e05a33" },
      { skill: "Design Systems", color: "#38bdf8" },
      { skill: "Typography", color: "#000000" },
    ]
  },
];
